import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Container, VStack, Heading, Text, Box, SimpleGrid, LinkBox, LinkOverlay, Badge, HStack,
} from "@chakra-ui/react";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../../brandConfig";

interface UpdateCard {
  title: string;
  description: string;
  path: string;
  date: string;
  badge: string;
  badgeColor: string;
}

const updates: UpdateCard[] = [
  {
    title: "March 2026 — Platform Walkthrough Video",
    description: "Full demo of the SurgReady patient journey: sign-up, payment, course access, and health assessment.",
    path: "/updates/march-2026-video",
    date: "23 March 2026",
    badge: "Video Update",
    badgeColor: "blue",
  },
];

const UpdatesIndex: React.FC = () => (
  <Box bg={getColor("background.main")} minHeight="100vh" display="flex" flexDirection="column">
    <NavbarWithCallToAction />

    <Container maxW="container.lg" py={10} flex="1">
      <VStack spacing={6} align="stretch">
        <Heading size="lg" color={getColor("text.primary")}>
          SurgReady Updates
        </Heading>
        <Text color={getColor("text.secondary")} fontSize="sm">
          Latest features, improvements, and video walkthroughs
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          {updates.map((update) => (
            <LinkBox
              key={update.path}
              as={Box}
              bg={getColor("background.light")}
              border="1px"
              borderColor={getColor("border.light")}
              borderRadius="xl"
              p={6}
              _hover={{ borderColor: getColor("primary"), transform: "translateY(-2px)" }}
              transition="all 0.2s"
            >
              <VStack align="start" spacing={3}>
                <HStack>
                  <Badge colorScheme={update.badgeColor} fontSize="xs">{update.badge}</Badge>
                  <Text fontSize="xs" color={getColor("text.muted")}>{update.date}</Text>
                </HStack>
                <LinkOverlay as={RouterLink} to={update.path}>
                  <Heading size="md" color={getColor("text.primary")}>{update.title}</Heading>
                </LinkOverlay>
                <Text color={getColor("text.secondary")} fontSize="sm">{update.description}</Text>
              </VStack>
            </LinkBox>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>

    <FooterWithFourColumns />
  </Box>
);

export default UpdatesIndex;
